import React from 'react';
import {
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonProgressBar,
  IonBadge
} from '@ionic/react';
import PropTypes from 'prop-types';
import Icon from 'src/components/Icon';
import Subscribe from 'src/components/Subscribe';
import DocumentsModal from 'src/components/DocumentsModal';
import ChatModal from 'src/components/ChatModal';
import BreakModal from 'src/components/BreakModal';
import DetailsModal from 'src/components/DetailsModal';
import { secondsToTime } from 'src/lib/time';
import './style.scss';

class StageBar extends React.Component {
  state = {
    openModal: null
  };

  openModal = (modalName) => this.setState({ openModal: modalName });

  closeModal = () => this.setState({ openModal: null });

  render() {
    const { openModal } = this.state;
    const {
      stage,
      fetching,
      job,
      unseenComments,
      stageContainer,
      onStartBreak,
      onEndBreak
    } = this.props;
    return (
      <div id="StageBar">
        <div className="border-bottom">
          <IonGrid>
            <IonRow className="ion-text-center">
              <IonCol
                className="col-btn"
                onClick={() => this.openModal('details')}
              >
                <div className="mb-2">
                  <Icon type="info-circle" />
                </div>
                <div>Details</div>
              </IonCol>
              <IonCol
                className="col-btn"
                onClick={() => this.openModal('docs')}
              >
                <div className="mb-2">
                  <Icon type="image" />
                </div>
                <div>Docs</div>
              </IonCol>
              <IonCol
                className="col-btn"
                onClick={() => this.openModal('chat')}
              >
                <div className="mb-2">
                  <IonText>
                    <Icon
                      type={
                        unseenComments.length ? 'comment-medical' : 'comments'
                      }
                    />
                  </IonText>
                </div>
                <div>
                  Chat{' '}
                  {unseenComments.length > 0 && (
                    <IonBadge
                      className={
                        unseenComments.length
                          ? 'animated infinite flash slower'
                          : ''
                      }
                    >
                      {unseenComments.length}
                    </IonBadge>
                  )}
                </div>
              </IonCol>
              <IonCol
                className="col-btn"
                onClick={() => this.openModal('break')}
              >
                <div className="mb-2">
                  <Icon type="pause" />
                </div>
                <div>Break</div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
        <StageProgress stage={stage} stageContainer={stageContainer} />
        <DocumentsModal
          isOpen={openModal === 'docs'}
          onClose={this.closeModal}
          jobId={job._id}
        />
        <ChatModal
          isOpen={openModal === 'chat'}
          onClose={this.closeModal}
          jobId={job._id}
        />
        <BreakModal
          isOpen={openModal === 'break' || job.on_break}
          onClose={this.closeModal}
          job={job}
          fetching={fetching}
          onStart={onStartBreak}
          onEnd={onEndBreak}
        />
        <DetailsModal
          isOpen={openModal === 'details'}
          onClose={this.closeModal}
          job={job}
        />
      </div>
    );
  }
}

StageBar.propTypes = {
  job: PropTypes.object.isRequired,
  stage: PropTypes.object.isRequired,
  unseenComments: PropTypes.array.isRequired,
  stageContainer: PropTypes.object.isRequired
};

export default (props) => {
  return (
    <Subscribe
      render={({ state }) => {
        return (
          <StageBar
            unseenComments={state.unseenComments.filter(
              (comment) => comment.job_id === props.job._id
            )}
            {...props}
          />
        );
      }}
    />
  );
};

const StageProgress = (props) => {
  return (
    <Subscribe
      to={[props.stageContainer]}
      render={({ state }) => {
        const { stage } = props;
        const { timePassed } = state;
        const estimate = stage.adjusted_estimate || stage.original_estimate;
        const isOverdue = timePassed > estimate;
        return (
          <React.Fragment>
            <IonGrid fluid className={isOverdue ? 'text-danger' : ''}>
              <IonText color={isOverdue ? 'danger' : undefined}>
                <IonRow>
                  <IonCol className="pr-0">{stage.title}</IonCol>
                  <IonCol size="auto" className="ion-text-right">
                    <span
                      // Use key to remount and get flash on stage change
                      key={stage.start_time}
                      className={`d-inline-block animated flash strong ${
                        isOverdue ? 'infinite' : ''
                      }`}
                      style={{ animationDuration: '2s' }}
                    >
                      {secondsToTime(timePassed)}
                    </span>
                    <span className="text-muted strong">
                      {' '}
                      / {secondsToTime(estimate)}
                    </span>
                  </IonCol>
                </IonRow>
              </IonText>
            </IonGrid>
            <IonProgressBar
              // use a new key to remount, else the progress
              // bar animates down to the start instead of just
              // reappearing as fresh
              // key={stage.start_time}
              color={isOverdue ? 'danger' : 'primary'}
              value={timePassed / estimate}
              buffer={timePassed / estimate}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
